"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Slider = exports.RightScrollArrow = exports.RightArrowBox = exports.LeftScrollArrow = exports.LeftArrowBox = exports.GradientRight = exports.GradientLeft = exports.ArrowWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1pzoupw-0"
})(["position:relative;width:100%;overflow:hidden;"]);
exports.Wrapper = Wrapper;
var Slider = _styledComponents["default"].div.withConfig({
  displayName: "styles__Slider",
  componentId: "sc-1pzoupw-1"
})(["display:flex;width:100%;height:100%;flex-wrap:nowrap;align-items:flex-start;overflow-x:scroll;-webkit-overflow-scrolling:touch;overflow-y:hidden;margin-bottom:", ";padding-left:1px;padding-right:1px;*{flex-shrink:0 ! important;}> *{overflow:visible !important;}"], function (props) {
  return props.sliderMarginBottom;
});
exports.Slider = Slider;
var Gradient = _styledComponents["default"].div.withConfig({
  displayName: "styles__Gradient",
  componentId: "sc-1pzoupw-2"
})(["position:absolute;top:0;height:100%;width:75px;background:linear-gradient(to right,white,rgba(255,255,255,0));pointer-events:none;"]);
var GradientLeft = (0, _styledComponents["default"])(Gradient).withConfig({
  displayName: "styles__GradientLeft",
  componentId: "sc-1pzoupw-3"
})(["left:0;z-index:90;"]);
exports.GradientLeft = GradientLeft;
var GradientRight = (0, _styledComponents["default"])(Gradient).withConfig({
  displayName: "styles__GradientRight",
  componentId: "sc-1pzoupw-4"
})(["right:0;transform:rotate(180deg);-webkit-transform:rotate(180deg);z-index:90;"]);
exports.GradientRight = GradientRight;
var ScrollArrow = _styledComponents["default"].i.withConfig({
  displayName: "styles__ScrollArrow",
  componentId: "sc-1pzoupw-5"
})(["border:solid rgb(249,99,2);border-width:0 3px 3px 0;padding:5px 5px 5px 5px;display:inline-block;"]);
var LeftScrollArrow = (0, _styledComponents["default"])(ScrollArrow).withConfig({
  displayName: "styles__LeftScrollArrow",
  componentId: "sc-1pzoupw-6"
})(["transform:rotate(135deg);-webkit-transform:rotate(135deg);"]);
exports.LeftScrollArrow = LeftScrollArrow;
var RightScrollArrow = (0, _styledComponents["default"])(ScrollArrow).withConfig({
  displayName: "styles__RightScrollArrow",
  componentId: "sc-1pzoupw-7"
})(["transform:rotate(-45deg);-webkit-transform:rotate(-45deg);"]);
exports.RightScrollArrow = RightScrollArrow;
var ArrowWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ArrowWrapper",
  componentId: "sc-1pzoupw-8"
})(["align-self:center;"]);
exports.ArrowWrapper = ArrowWrapper;
var ArrowBox = _styledComponents["default"].div.withConfig({
  displayName: "styles__ArrowBox",
  componentId: "sc-1pzoupw-9"
})(["position:absolute;top:45%;transform:translateY(-50%);width:1em;height:2em;;font-size:1.5em;background:white;border:1px lightgrey solid;cursor:pointer;display:none;&:hover{background-color:#eee;}@media (min-width:768px){display:flex;justify-content:center;align-items:center;align-content:center;}@media (min-width:360px){", "}"], function (props) {
  return props.oneItemPerSlide && (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;align-content:center;"]);
});
var LeftArrowBox = (0, _styledComponents["default"])(ArrowBox).withConfig({
  displayName: "styles__LeftArrowBox",
  componentId: "sc-1pzoupw-10"
})(["left:.5em;padding-left:.25em;z-index:100;"]);
exports.LeftArrowBox = LeftArrowBox;
var RightArrowBox = (0, _styledComponents["default"])(ArrowBox).withConfig({
  displayName: "styles__RightArrowBox",
  componentId: "sc-1pzoupw-11"
})(["right:.5em;padding-right:.25em;z-index:100;"]);
exports.RightArrowBox = RightArrowBox;
//# sourceMappingURL=styles.js.map